import { http } from '@/shared/httpWrapper';
import { validateRegexOnServer, type RegexValidationResult } from '@/shared/helpers/api';

/**
 * Checks if the supplied regex is valid using JavaScript's RegExp.
 * Returns null if valid, a string describing the error if invalid.
 */
export function validateRegex(regex: string): string | null {
    try {
        new RegExp(regex);
        return null;
    } catch (e) {
        return 'Error in regex: ' + (e as Error).message;
    }
}

/**
 * Validates a regex pattern (and optionally a value against it) using the
 * server-side .NET regex engine.
 * Returns the validation result including whether the pattern is valid
 * and whether the value matches.
 */
export async function validateRegexServerSide(regex: string, value?: string): Promise<RegexValidationResult> {
    if (!regex) return { isValid: true, isMatch: true };

    try {
        return await validateRegexOnServer(http, regex, value);
    } catch {
        return { isValid: false, isMatch: false, error: 'Unable to validate (server unavailable)' };
    }
}
